import { form, Form, Formio } from "@formio/react";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const Viewsubmission = (props) => {
  const params = useParams();

  const [formrendering, setformrendering] = useState({});
  const [Gotformdata, setGotformdata] = useState(undefined);

  useEffect(() => {
    localStorage.setItem("formioToken", process.env.REACT_APP_X_JWT_TOKEN);
    localStorage.setItem(
      "formUrl",
      `http://localhost:3001/form/${props.formid}`
    );
    formrender(props.formid);
    const halfsubmissionapi = `form/${props.formid}/submission/${props.submissionid}`;
    GetSubmissionData(halfsubmissionapi);
  }, []);

  const formrender = async (formid) => {
    const response = await fetch(`http://localhost:3001/form/${formid}`, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        //   'Content-Type': 'application/json',

        "x-jwt-token": process.env.REACT_APP_X_JWT_TOKEN,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      // body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
      .then((data) => {
        data.json().then((data) => {
          setformrendering(data);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const GetSubmissionData = async (halfsubmissionapi) => {
    const response = await fetch(`http://localhost:3001/${halfsubmissionapi}`, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        //   'Content-Type': 'application/json',

        "x-jwt-token": process.env.REACT_APP_X_JWT_TOKEN,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      // body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
      .then((data) => {
        data.json().then((data) => {
          setGotformdata(data);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const URL = `http://localhost:3001/form/${props.formid}`;

  const ResubmitReturnedfromclerk = async (payloadofaplid) => {
    const response = await fetch(
      `http://localhost:8000/camunda/engine-rest-ext/v1/message`,
      {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        // credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json",
          Authorization: process.env.REACT_APP_5000_BEARER_TOKEN,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(payloadofaplid), // body data type must match "Content-Type" header
      }
    );
  };

  const onSubmitHandler = async (submission) => {
    const formio = new Formio(
      `http://localhost:3001/form/${props.formid}/submission/${props.submissionid}`
    );

    formio
      .saveSubmission({ _id: submission._id, data: submission.data })
      .then((result) => {});

    if (submission.data.applicationStatus == "Resubmit") {
      const response = await fetch(
        `http://localhost:5000/application/${submission.data.applicationId}`,
        {
          method: "GET", // *GET, POST, PUT, DELETE, etc.
          mode: "cors", // no-cors, *cors, same-origin
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          // credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            //   'Content-Type': 'application/json',
            Authorization: process.env.REACT_APP_5000_BEARER_TOKEN,

            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          redirect: "follow", // manual, *follow, error
          referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          // body: JSON.stringify(data) // body data type must match "Content-Type" header
        }
      );
      const data = await response.json();

      const payloadofaplid = {
        messageName: "application_resubmitted",
        processInstanceId: data.processInstanceId,
      };
      ResubmitReturnedfromclerk(payloadofaplid);
    }
  };

  return (
    <>
      {formrendering && Gotformdata && (
        <Form
          form={formrendering}
          onSubmit={onSubmitHandler}
          submission={Gotformdata}
        ></Form>
      )}
    </>
  );
};

export default Viewsubmission;
